export class CoreTaskData {
    studentnummer: string;
    studentnaam: string;
    roc: string;
    roC_Contactpersoon: string;
    bpV_Bedrijf: string;
    bpV_Contactpersoon: string;
    beoordelaar1_Naam: string;
    beoordelaar2_Naam: string;
    beoordelaar1_Functie: string;
    beoordelaar2_Functie: string;
    beoordelaar1_Verwantwoording: string;
    beoordelaar2_Verwantwoording: string;
    beoordelaar1_Datum: string;
    beoordelaar2_Datum: string;
    student_Datum: string;
}



// WEBPACK FOOTER //
// ./src/app/examination/coreTaskData.ts